module.exports = __webpack_public_path__ + "img/bb_g1_t_antenna-06.baff0850.svg";